import React, { useMemo } from 'react';

import { Stack } from '@gogame/components';
import { useScreenState } from '@gogame/screens';

import Chart from './Chart';
import { ChartDataProvider } from './ChartDataContext';

const TrackerCharts = ({ withPaper = true, tooltipPosStrategy }) => {
  const { charts } = useScreenState();

  const widthP = Number((100 / charts.length).toFixed(2));
  const canAdd = useMemo(() => charts.length <= 1, [charts.length]);

  return (
    <Stack direction={'row'} spacing={2}>
      {charts.map(({ metrics }, index) => {
        return (
          <Stack
            key={`${index}_${metrics && metrics.toString()}`}
            style={{ width: `${widthP}%` }}
          >
            <ChartDataProvider index={index}>
              <Chart
                index={index}
                withPaper={withPaper}
                tooltipPosStrategy={tooltipPosStrategy}
                canAdd={canAdd}
              />
            </ChartDataProvider>
          </Stack>
        );
      })}
    </Stack>
  );
};

export default TrackerCharts;
